<template>
  <Card class="card p-5 shadow-sm" :title="response.contact ? response?.contact.firstname : response.email">
      <br>
      <Card class="card p-5 mx-10 mb-2">
          <h4>{{ response.nps?.nps_description }}</h4>
          <div class="p-4 back">
            <p>{{ response.note }}</p>
          </div>
      </Card>
      <Card class="card p-5 mx-10 mb-2" v-for="(resp, index) in response.data" :key="index">
          <h4>{{ resp.label }}</h4>
          <div class="p-4 back">
            <p>{{ displayValue(resp?.value) }}</p>
          </div>
      </Card>
  </Card> 
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Card from "@/components/Card.vue";

const route = useRoute()
const store = useStore()
const response = ref({})
const getting = ref(false)

watch(() => route.query.tab, (value) => {
  if(value == 'tab-nps' && route.params.response) {
    loadNpsResponse()
  }
})

async function loadNpsResponse() {
  getting.value = true
  await store.dispatch('eventNps/getNpsResponse', route.params.response).then((res) => {
    response.value = {...res?.data?.response, data: JSON.parse(res?.data?.response?.data)}
  }).finally(() => {getting.value = false})
} 

const displayValue = (resp) => {
  return Array.isArray(resp) ? resp.join(', ') : resp;
};

onMounted(async() => {
  if(route.params.response && route.query.tab == 'tab-nps'){
    loadNpsResponse()
  }
})

</script>

<style scoped>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 5px;
  width: auto;
}
</style>
